<template>
  <div class="comment__content" style="overflow-y: auto;">
    <f-comment-item />
  </div>
</template>

<script>
  import FCommentItem from './CommentItem';

  export default {
    name: 'f-comment-content',
    components: {
      FCommentItem
    }
  }
</script>
